module.exports = __webpack_public_path__ + "static/media/ac.ef6b7c4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/ac.png
// module id = 812
// module chunks = 0